export default Object.freeze({
    Red: 1,
    Blue: 2,
    Green: 3,
    Colorless: 4
});